<ng-container *ngIf="isBrowser">
    <ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>
</ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homefilterdesk>
    <button class="tmpbtn w100 tmp-left tmpnorightborder" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <mat-icon fontIcon="location_on"></mat-icon>
        <span multilang class="ellipsis">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homemodeMobile>
    <button class="tmpbtn w100 tmpnobottomborder tmp-top mw3" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <mat-icon fontIcon="location_on"></mat-icon>
        <span multilang class="ellipsis">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #nohomefilter>
    <ng-container *ngIf="mode === 'nohomesmall' else mbfilters">
        <b>{{suffix}} {{zielText !== 'Anmietungs und Rückgabeort' ? zielText : '' }}</b>
    </ng-container>
</ng-template>
<ng-template #mbfilters>
    <button class="tmpbtn w100 tmpnobottomborder tmp-top" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <mat-icon fontIcon="location_on"></mat-icon>
        <span multilang class="ellipsis">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" placeholder="Wohin?" [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus"
                    class="searchinput">
                <button matRipple (click)="clearText()" *ngIf="mySearchControl?.value?.length > 0">
                    <mat-icon class="btnico">clear</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" placeholder="Wohin?" [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus"
                    class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper customscroll">
        <ng-container *ngIf="mySearchControl?.value?.length > 0 else defaultDatas">
            <ng-container *ngFor="let item of (searchObj | async)">
                <ng-container *ngTemplateOutlet="land context:{item:item}"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>


<ng-template #defaultDatas>
    <span multilang class="tt-text">AKTUELL BELIEBT</span>
    <ng-container *ngFor="let item of defaultdatas">
        <ng-container [ngSwitch]="item.type">
            <ng-container *ngSwitchCase="1">
                <ng-container *ngTemplateOutlet="land context:{item:item}"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="-1">
                <ng-container *ngTemplateOutlet="egal context:{item:item}"></ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #egal let-item="item">
    <button class="item-wrapper" (click)="selectValue(item)">
        <mat-icon class="egal-ico">mode_of_travel</mat-icon>
        <ng-template #icon>
            <mat-icon class="item-icon">push_pin</mat-icon>
        </ng-template>
        <div class="item-body">
            <span multilang class="first-item-line">{{item.name}}</span>
        </div>
    </button>
</ng-template>

<ng-template #land let-item="item">
    <button class="item-wrapper" (click)="selectValue(item)">
        <mat-icon class="item-icon">flight</mat-icon>
        <div class="item-body">
            <span multilang class="first-item-line">{{item.name}} ({{item.code}})</span>
            <small class="second-item-line">{{item?.country?.name}}</small>
        </div>
    </button>
</ng-template>